import { render } from "./LogsignLayout.vue?vue&type=template&id=7b388fbb"
import script from "./LogsignLayout.vue?vue&type=script&lang=js"
export * from "./LogsignLayout.vue?vue&type=script&lang=js"

import "./LogsignLayout.vue?vue&type=style&index=0&id=7b388fbb&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__